module.exports = __webpack_public_path__ + "0335faa2ae7223d40c7d6f2a262b431c.svg";